import React from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';

import { ChevronRight } from '@bibliocommons/base-icons';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';

import Heading from 'app/components/shared/Heading';
import { bibsMappedProps } from 'app/shapes/browse/rows';
import DisplayBibSlide from './DisplayBibSlide';

import './DisplayBibs.scss';

const BibsRow = ({
  additionalAnalyticsPayload,
  displayBibs,
  hasHistoryRoutingForTitles,
  maxNumBibs,
  styleSlideOverlayText,
  title,
  titleScreenReaderLabel,
  titleUrl,
  titleTag,
  trackBibClick,
  trackTitleClick
}) => {
  const onTitleClick = () => {
    trackTitleClick({ ...additionalAnalyticsPayload, linkText: title, linkUrl: titleUrl });
  };

  const screenReaderTextForTitle = titleScreenReaderLabel || title;

  return (
    <div className="cp-display-bibs">
      <Heading className="heading" tagName={titleTag} size="moderate" variant>
        {hasHistoryRoutingForTitles ? (
          <Link dataKey={titleUrl} onAuxClick={onTitleClick} onClick={onTitleClick} to={titleUrl}>
            <span aria-hidden>{title}</span>
            <ScreenReaderMessage>{screenReaderTextForTitle}</ScreenReaderMessage>
            <ChevronRight />
          </Link>
        ) : (
          <a href={titleUrl} onAuxClick={onTitleClick} onClick={onTitleClick}>
            <span aria-hidden>{title}</span>
            <ScreenReaderMessage>{screenReaderTextForTitle}</ScreenReaderMessage>
            <ChevronRight />
          </a>
        )}
      </Heading>
      <ul className="display-bibs__list">
        {displayBibs.map((displayBib, index) => {
          const itemPosition = index + 1; // + 1 so that the count is 1-based.

          return (
            <li className={`display-bibs__item display-bibs__item--of-${maxNumBibs}`} key={displayBib.metadataId}>
              <DisplayBibSlide
                className="display-bibs__slide"
                displayBib={displayBib}
                styleOverlayText={styleSlideOverlayText}
                trackClick={() =>
                  trackBibClick({ ...additionalAnalyticsPayload, displayBib, itemPosition, uiContainerTitle: title })}
              />
            </li>
          );
        })}
      </ul>
    </div>
  );
};

BibsRow.defaultProps = {
  additionalAnalyticsPayload: {},
  maxNumBibs: 8,
  styleSlideOverlayText: null,
  titleTag: 'h2'
};

BibsRow.propTypes = {
  ...bibsMappedProps,
  additionalAnalyticsPayload: PropTypes.object,
  maxNumBibs: PropTypes.number,
  styleSlideOverlayText: PropTypes.object,
  titleTag: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
  trackBibClick: PropTypes.func.isRequired,
  trackTitleClick: PropTypes.func.isRequired
};

export default BibsRow;
